export default {
  inject: ['i18n']
};